import { usePrismItemStore } from 'stores/usePrismItemStore';

function buildMobileUploadURL() {
  const { qrLinkedMobileUploader } = window;
  const prismItem = usePrismItemStore.getState().prismItem;

  const uploaderConfigPath =
    qrLinkedMobileUploader?.desktopUploaderConfigPath || '';

  if (prismItem?.id && prismItem?.sec) {
    const params = new URLSearchParams({
      prism_id: prismItem.id,
      sec: prismItem.sec,
    });

    return `${uploaderConfigPath}?${params}`;
  }

  return uploaderConfigPath;
}

export async function fetchDesktopUploaderConfig() {
  try {
    const response = await fetch(buildMobileUploadURL());

    if (response.ok) {
      return await response.json();
    }

    return {
      error: 'Service Unavailable, please refresh the page and try again.',
    };
  } catch (error) {
    return {
      error: error,
    };
  }
}
